"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
var _validate = require("@/utils/validate");
var _LogDetail = _interopRequireDefault(require("../LogDetail"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    LogDetail: _LogDetail.default
  },
  data: function data() {
    return {
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      systemSuffix: '',
      systemSuffixOptions: [],
      total: 0,
      currentId: null,
      isShowDetail: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        interfaceSn: '',
        errorCode: '',
        detailErrorCode: '',
        startTime: '',
        endTime: '',
        systemSuffix: ''
      },
      form: {}
    };
  },
  computed: {},
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    // this.fetchData()
    this.getLookupTypeCode();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          interfaceSn: this.searchVal.interfaceSn,
          errorCode: this.searchVal.errorCode,
          detailErrorCode: this.searchVal.detailErrorCode,
          startTime: this.searchVal.startTime,
          endTime: this.searchVal.endTime,
          systemSuffix: this.searchVal.systemSuffix
        }
      };
      this.listLoading = true;
      this.$api.apiLog.getLogList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
        // 数据请求成功后修改对应日志表名状态
        _this.systemSuffix = _this.searchVal.systemSuffix;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    check: function check(row) {
      var _this2 = this;
      this.currentId = row.interfaceLogPk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this2.isShowDetail = true;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.isLoading = true;
        _this3.$api.apiLog.getLogDetail(_this3.currentId, _this3.systemSuffix).then(function (res) {
          _this3.isLoading = false;
          var _res$data = res.data,
            interfaceLogPk = _res$data.interfaceLogPk,
            interfaceSn = _res$data.interfaceSn,
            loginCode = _res$data.loginCode,
            requestMethod = _res$data.requestMethod,
            consumeTime = _res$data.consumeTime,
            ipAddr = _res$data.ipAddr,
            url = _res$data.url,
            fullUrl = _res$data.fullUrl,
            urlPattern = _res$data.urlPattern,
            referer = _res$data.referer,
            userAgent = _res$data.userAgent,
            errorCode = _res$data.errorCode,
            detailErrorCode = _res$data.detailErrorCode,
            queryString = _res$data.queryString,
            sessionId = _res$data.sessionId,
            token = _res$data.token,
            extAttr1 = _res$data.extAttr1,
            extAttr2 = _res$data.extAttr2,
            extAttr3 = _res$data.extAttr3,
            extAttr4 = _res$data.extAttr4;
          var _res$data2 = res.data,
            reqTime = _res$data2.reqTime,
            pathVariable = _res$data2.pathVariable,
            interfaceParamJson = _res$data2.interfaceParamJson,
            interfaceResponseJson = _res$data2.interfaceResponseJson;
          reqTime = (0, _index.parseTime)(reqTime);
          pathVariable = (0, _validate.isJSON)(pathVariable) ? JSON.stringify(JSON.parse(pathVariable), null, 2) : pathVariable;
          interfaceResponseJson = (0, _validate.isJSON)(interfaceResponseJson) ? JSON.stringify(JSON.parse(interfaceResponseJson), null, 2) : interfaceResponseJson;
          interfaceParamJson = (0, _validate.isJSON)(interfaceParamJson) ? JSON.stringify(JSON.parse(interfaceParamJson), null, 2) : interfaceParamJson;
          _this3.form = {
            interfaceLogPk: interfaceLogPk,
            interfaceSn: interfaceSn,
            loginCode: loginCode,
            requestMethod: requestMethod,
            reqTime: reqTime,
            consumeTime: consumeTime,
            ipAddr: ipAddr,
            url: url,
            fullUrl: fullUrl,
            urlPattern: urlPattern,
            referer: referer,
            userAgent: userAgent,
            errorCode: errorCode,
            detailErrorCode: detailErrorCode,
            queryString: queryString,
            sessionId: sessionId,
            token: token,
            extAttr1: extAttr1,
            extAttr2: extAttr2,
            extAttr3: extAttr3,
            extAttr4: extAttr4,
            'pathVariable': {
              'isJson': true,
              'data': pathVariable
            },
            'interfaceParamJson': {
              'isJson': true,
              'data': interfaceParamJson
            },
            'interfaceResponseJson': {
              'isJson': true,
              'data': interfaceResponseJson
            }
          };
          resolve(_this3.form);
        }).catch(function () {
          _this3.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this4 = this;
      if (this.$store.getters.SC_SYSTEM_LOGS_SUFFIX_MAPPING && this.$store.getters.SC_SYSTEM_LOGS_SUFFIX_MAPPING.length) {
        this.generateLookup_SC_SYSTEM_LOGS_SUFFIX_MAPPING(this.$store.getters.SC_SYSTEM_LOGS_SUFFIX_MAPPING);
      } else {
        this.$api.lookup.getLookupMultiTypeCodeDetail(['SC_SYSTEM_LOGS_SUFFIX_MAPPING']).then(function (res) {
          if (res.data) {
            if (res.data.SC_SYSTEM_LOGS_SUFFIX_MAPPING && res.data.SC_SYSTEM_LOGS_SUFFIX_MAPPING.length > 0) {
              _this4.$store.dispatch('nocache/setScSystemLogsSuffixMapping', res.data.SC_SYSTEM_LOGS_SUFFIX_MAPPING);
              _this4.generateLookup_SC_SYSTEM_LOGS_SUFFIX_MAPPING(res.data.SC_SYSTEM_LOGS_SUFFIX_MAPPING);
            }
          }
        }).catch(function () {});
      }
    },
    generateLookup_SC_SYSTEM_LOGS_SUFFIX_MAPPING: function generateLookup_SC_SYSTEM_LOGS_SUFFIX_MAPPING(dataList) {
      // 将查找值转换成所需数据格式
      this.systemSuffixOptions = dataList.map(function (item) {
        var valueName = item.valueName,
          valueCode = item.valueCode;
        return {
          valueName: valueName,
          valueCode: valueCode
        };
      });
      this.searchVal.systemSuffix = this.systemSuffixOptions[0].valueCode;
    }
  }
};